import _styled from "styled-components";
const _excluded = ["children", "className", "style", "inherit"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import { motion } from 'framer-motion';
import PropTypes from 'prop-types';
import { stylePropType } from '@adsk/alloy-react-theme';
/**
 * A Animation Provides wrapper for framer-motion {motion.div}
 * API: https://www.framer.com/api/motion/animation/
 */
const Animation = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      children,
      className,
      style,
      inherit = false
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(_StyledMotionDiv, _extends({
    ref: ref,
    className: className,
    inherit: inherit
  }, props, {
    $_css: [style]
  }), children);
});
Animation.displayName = 'Animation';
Animation.propTypes = {
  /** Animation content */
  children: PropTypes.any,
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string,
  // (JSX attribute) initial?: string | boolean | MakeCustomValueType<TargetProperties> | string[]
  // Properties, variant label or array of variant labels to start in.
  // Set to false to initialise with the values in animate (disabling the mount animation)
  // <Animation initial={{ opacity: 1 }} />
  // <Animation initial="visible" variants={variants} />
  // <Animation initial={["visible", "active"]} variants={variants} />
  // <Animation initial={false} animate={{ opacity: 0 }} />
  initial: PropTypes.oneOfType([PropTypes.string, PropTypes.bool, PropTypes.object]),
  // Values to animate to, variant label(s), or AnimationControls.
  // <Animation animate={{ opacity: 1 }} />
  // <Animation animate="visible" variants={variants} />
  // <Animation animate={["visible", "active"]} variants={variants} />
  // <Animation animate={animation} />
  animate: PropTypes.oneOfType([PropTypes.string, PropTypes.bool, PropTypes.object]),
  // Set to false to prevent inheriting variant changes from its parent.
  inherit: PropTypes.bool,
  // Default transition. If no transition is defined in animate, it will use the transition defined here.
  // <Animation
  //   transition={{
  //     type: 'spring',
  //     damping: 10,
  //     stiffness: 100,
  //   }}
  //   animate={{ scale: 1.2 }}
  // />
  transition: PropTypes.object
};
export default Animation;
var _StyledMotionDiv = _styled(motion.div).withConfig({
  displayName: "Animation___StyledMotionDiv",
  componentId: "sc-pv858p-0"
})(["", ""], p => p.$_css);
//# sourceMappingURL=Animation.js.map